import { Node, NodeData } from '@contentful/rich-text-types';

export interface ValidNode extends Node {
    data: {
        target: {
            fields: NodeData['target']['fields'];
            sys: {
                id: string;
                contentType: {
                    sys: {
                        id: string;
                    };
                };
            };
        };
    };
}

export const isValidNode = (node: Node): node is ValidNode => {
    const target = node.data?.target || {};
    return (
        !!target.fields &&
        typeof target.fields === 'object' &&
        typeof target.sys?.id === 'string' &&
        typeof target.sys.contentType?.sys?.id === 'string'
    );
};
